export default function getEnvValue(name: string) {
  if ((window as any).env === undefined) {
    throw new Error('env.js is missing');
  }

  const env = (window as any).env;

  if (env[name] === undefined) {
    throw new Error(`${name} is missing in env.js`);
  }

  return env[name];
}
